(function () {
  "use strict";
  
  if (window.__ReserveTimerDawn) return;

  const DURATION_MS = 10 * 60 * 1000;
  const END_KEY = "reserve_timer_end_dawn_v1";
  const CART_STATE_KEY = "reserve_timer_cart_state_dawn";
  const ITEM_COUNT_KEY = "reserve_timer_item_count_dawn";
  const FIRST_VISIT_KEY = "reserve_timer_first_visit_dawn";

  let interval = null;
  let lastRenderedTime = null;
  let cartEmptiedByTimer = false;
  let isEmptyingCart = false;
  let lastCheckedCount = -1;
  let lastCheckedEmpty = null;
  let isInitialLoad = true;
  let elementsFound = false;
  let cachedTimerState = null;

  function getEnd() {
    try {
      const v = localStorage.getItem(END_KEY);
      const n = v ? parseInt(v, 10) : null;
      return n && !isNaN(n) ? n : null;
    } catch (e) {
      return null;
    }
  }

  function setEnd(timestamp) {
    try {
      localStorage.setItem(END_KEY, String(timestamp));
    } catch (e) {}
  }

  function getCartState() {
    try {
      return localStorage.getItem(CART_STATE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setCartState(state) {
    try {
      localStorage.setItem(CART_STATE_KEY, state);
    } catch (e) {}
  }

  function getStoredItemCount() {
    try {
      const v = localStorage.getItem(ITEM_COUNT_KEY);
      return v ? parseInt(v, 10) : 0;
    } catch (e) {
      return 0;
    }
  }

  function setStoredItemCount(count) {
    try {
      localStorage.setItem(ITEM_COUNT_KEY, String(count));
    } catch (e) {}
  }

  function isFirstVisit() {
    try {
      return !localStorage.getItem(FIRST_VISIT_KEY);
    } catch (e) {
      return true;
    }
  }

  function markVisited() {
    try {
      localStorage.setItem(FIRST_VISIT_KEY, "true");
    } catch (e) {}
  }

  function format(sec) {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  }

  function isCartEmpty() {
    // Dawn theme uses cart-drawer or cart-notification
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!drawer) return true;
    
    // Check if cart has the empty class or no items
    const isEmpty = drawer.classList.contains('is-empty') || 
                    drawer.hasAttribute('data-empty') ||
                    getCartItemCount() === 0;
    return isEmpty;
  }

  function getCartItemCount() {
    // Dawn theme cart items selector
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!drawer) return 0;
    
    // Try multiple selectors for Dawn theme
    const lineItems = drawer.querySelectorAll('.cart-item:not(.cart-item--gift)') ||
                      drawer.querySelectorAll('cart-item') ||
                      drawer.querySelectorAll('.line-item:not(.gift-item)');
    
    return lineItems.length;
  }

  function calculateRemainingSeconds() {
    const end = getEnd();
    if (!end) return 0;
    
    const remainingMs = Math.max(end - Date.now(), 0);
    return Math.ceil(remainingMs / 1000);
  }

  function applyTimerState(root, msg, time, tail, state) {
    if (state.isExpired) {
      root.classList.add("is-expired");
      msg.textContent = state.msgText;
      time.textContent = state.timeText;
      tail.textContent = state.tailText;
    } else {
      root.classList.remove("is-expired");
      msg.textContent = state.msgText;
      time.textContent = state.timeText;
      tail.textContent = state.tailText;
    }
  }

  function renderTimer(forceUpdate) {
    const root = document.getElementById("reserve-timer-dawn");
    const msg = document.getElementById("rt-msg-dawn");
    const time = document.getElementById("rt-time-dawn");
    const tail = document.getElementById("rt-tail-dawn");
    
    if (!root || !msg || !time || !tail) {
      elementsFound = false;
      return;
    }

    elementsFound = true;
    const sec = calculateRemainingSeconds();
    
    if (!forceUpdate && sec === lastRenderedTime) return;
    
    lastRenderedTime = sec;

    const state = {
      isExpired: sec <= 0,
      msgText: sec <= 0 ? "Place your order now" : "Your order is reserved for",
      timeText: sec <= 0 ? "00:00" : format(sec),
      tailText: sec <= 0 ? "" : "minutes"
    };

    cachedTimerState = state;
    applyTimerState(root, msg, time, tail, state);
  }

  function checkAndHandleCartState() {
    if (cartEmptiedByTimer || isEmptyingCart) return;
    
    const isEmpty = isCartEmpty();
    const currentItemCount = getCartItemCount();
    const currentState = getCartState();
    const storedCount = getStoredItemCount();
    const remainingSeconds = calculateRemainingSeconds();
    const timerExpired = remainingSeconds <= 0;
    
    if (isEmpty === lastCheckedEmpty && currentItemCount === lastCheckedCount) {
      return;
    }
    
    const wasEmpty = lastCheckedEmpty;
    const previousCount = lastCheckedCount;
    
    lastCheckedEmpty = isEmpty;
    lastCheckedCount = currentItemCount;
    
    // Cart went from having items to empty
    if (isEmpty && !wasEmpty && currentState === "has-items") {
      setCartState("empty");
      setStoredItemCount(0);
      renderTimer(true);
    }
    // Adding items to cart when timer has expired
    else if (previousCount === 0 && currentItemCount > 0 && timerExpired) {
      const newEnd = Date.now() + DURATION_MS;
      setEnd(newEnd);
      setCartState("has-items");
      setStoredItemCount(currentItemCount);
      lastRenderedTime = null;
      renderTimer(true);
    }
    // Adding items back when timer is still running (cart was empty)
    else if (!isEmpty && wasEmpty && currentItemCount > 0 && !timerExpired) {
      setCartState("has-items");
      setStoredItemCount(currentItemCount);
      renderTimer(true);
    }
    // Adding first items when timer is still running
    else if (previousCount === 0 && currentItemCount > 0 && !timerExpired) {
      setCartState("has-items");
      setStoredItemCount(currentItemCount);
      renderTimer(true);
    }
    // Item count changed (added/removed items but cart not empty)
    else if (!isEmpty && currentItemCount > 0 && currentItemCount !== storedCount) {
      setStoredItemCount(currentItemCount);
      if (currentState !== "has-items") {
        setCartState("has-items");
      }
      renderTimer(true);
    }
  }

  function tick() {
    if (!elementsFound) return;
    
    const sec = calculateRemainingSeconds();
    
    if (sec <= 0) {
      const isEmpty = isCartEmpty();
      const count = getCartItemCount();
      
      if (!isEmpty && count > 0 && !cartEmptiedByTimer && !isEmptyingCart) {
        // Timer expired with items - just show expired state
      }
    }
    
    renderTimer(false);
  }

  function observeCartDrawer() {
    // Dawn theme uses custom elements
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!drawer) {
      setTimeout(observeCartDrawer, 100);
      return;
    }

    let debounceTimeout = null;
    function debouncedCheck() {
      if (debounceTimeout) clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(checkAndHandleCartState, 150);
    }

    // Observe class changes
    const drawerObserver = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === "class" || mutations[i].attributeName === "data-empty") {
          debouncedCheck();
          break;
        }
      }
    });

    drawerObserver.observe(drawer, { 
      attributes: true,
      attributeFilter: ["class", "data-empty"]
    });

    // Observe cart items changes
    const itemsContainer = drawer.querySelector('.cart-items') || drawer.querySelector('[data-cart-items]');
    if (itemsContainer) {
      const itemsObserver = new MutationObserver(function(mutations) {
        let itemsChanged = false;
        
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i];
          if (mutation.type === 'childList') {
            for (let j = 0; j < mutation.addedNodes.length; j++) {
              if (mutation.addedNodes[j].classList && 
                  (mutation.addedNodes[j].classList.contains('cart-item') || 
                   mutation.addedNodes[j].tagName === 'CART-ITEM')) {
                itemsChanged = true;
                break;
              }
            }
            for (let j = 0; j < mutation.removedNodes.length; j++) {
              if (mutation.removedNodes[j].classList && 
                  (mutation.removedNodes[j].classList.contains('cart-item') || 
                   mutation.removedNodes[j].tagName === 'CART-ITEM')) {
                itemsChanged = true;
                break;
              }
            }
          }
          if (itemsChanged) break;
        }
        
        if (itemsChanged) debouncedCheck();
      });

      itemsObserver.observe(itemsContainer, {
        childList: true,
        subtree: false
      });
    }

    // Also listen for Dawn's custom cart update events
    document.addEventListener('cart:updated', debouncedCheck);
    document.addEventListener('cart:refresh', debouncedCheck);
  }

  function observeTimerElement() {
    const bodyObserver = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        for (let j = 0; j < mutation.addedNodes.length; j++) {
          const node = mutation.addedNodes[j];
          
          let timerElement = null;
          if (node.id === "reserve-timer-dawn") {
            timerElement = node;
          } else if (node.querySelector) {
            timerElement = node.querySelector("#reserve-timer-dawn");
          }
          
          if (timerElement && cachedTimerState) {
            const msg = timerElement.querySelector("#rt-msg-dawn");
            const time = timerElement.querySelector("#rt-time-dawn");
            const tail = timerElement.querySelector("#rt-tail-dawn");
            
            if (msg && time && tail) {
              applyTimerState(timerElement, msg, time, tail, cachedTimerState);
              elementsFound = true;
            }
          }
        }
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function checkOnLoad() {
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!drawer) {
      setTimeout(checkOnLoad, 100);
      return;
    }

    setTimeout(function() {
      const isEmpty = isCartEmpty();
      const itemCount = getCartItemCount();
      const existingEnd = getEnd();
      const remainingMs = existingEnd ? Math.max(existingEnd - Date.now(), 0) : 0;
      const timerExpired = remainingMs <= 0;
      const firstVisit = isFirstVisit();
      
      if (firstVisit) {
        if (itemCount > 0) {
          // First visit with items - start the timer
          const newEnd = Date.now() + DURATION_MS;
          setEnd(newEnd);
          setCartState("has-items");
          setStoredItemCount(itemCount);
          markVisited();
        } else {
          // First visit with empty cart - don't start timer, just mark visited
          markVisited();
          setCartState("empty");
          setStoredItemCount(0);
          setEnd(0);
        }
      }
      else if (!existingEnd || (timerExpired && itemCount > 0)) {
        const newEnd = Date.now() + DURATION_MS;
        setEnd(newEnd);
        setCartState(itemCount > 0 ? "has-items" : "empty");
        setStoredItemCount(itemCount);
      }
      else if (existingEnd && !timerExpired) {
        setCartState(itemCount > 0 ? "has-items" : "empty");
        setStoredItemCount(itemCount);
      }
      else if (timerExpired && itemCount === 0) {
        setCartState("empty");
        setStoredItemCount(0);
      }
      
      lastCheckedEmpty = isEmpty;
      lastCheckedCount = itemCount;
      isInitialLoad = false;
      
      renderTimer(true);
    }, 500);
  }

  function initialize() {
    if (!interval) {
      interval = setInterval(tick, 1000);
    }

    observeCartDrawer();
    observeTimerElement();
    checkOnLoad();
  }

  window.__ReserveTimerDawn = { 
    init: initialize,
    forceUpdate: function() {
      lastRenderedTime = null;
      renderTimer(true);
    },
    reset: function() {
      const newEnd = Date.now() + DURATION_MS;
      setEnd(newEnd);
      lastRenderedTime = null;
      renderTimer(true);
    },
    getRemaining: calculateRemainingSeconds,
    clearFirstVisit: function() {
      try {
        localStorage.removeItem(FIRST_VISIT_KEY);
        console.log("✅ First visit flag cleared");
      } catch (e) {
        console.error("Failed to clear first visit flag");
      }
    },
    debug: function() {
      console.log("🐛 Reserve Timer Debug (Dawn):");
      console.log("  Empty:", isCartEmpty());
      console.log("  Count:", getCartItemCount());
      console.log("  State:", getCartState());
      console.log("  Stored Count:", getStoredItemCount());
      console.log("  Remaining:", calculateRemainingSeconds() + "s");
      console.log("  End timestamp:", new Date(getEnd()).toLocaleTimeString());
      console.log("  First visit:", isFirstVisit());
      console.log("  Cached state:", cachedTimerState);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    setTimeout(initialize, 50);
  }
})();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just tehe section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
function initializeAccordions() {
  document.querySelectorAll('.product-info [id^="Details-"] summary').forEach((summary) => {
    // Skip if already initialized
    if (summary.hasAttribute('data-accordion-initialized')) return;
    
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    summary.setAttribute('data-accordion-initialized', 'true');
    
    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    
    const details = summary.parentNode;
    const content = summary.nextElementSibling;
    
    function setupAccordionStyles() {
      // Only apply styles if the element is visible
      const container = details.closest('.measurement--collapsible');
      if (container && container.style.display === 'none') {
        return; // Skip setup if parent is hidden
      }
      
      // Set initial styles for animation
      if (!details.style.transition) {
        details.style.transition = 'height 0.3s ease-out';
        details.style.overflow = 'hidden';
      }
      
      // Set proper initial height
      if (details.hasAttribute('open')) {
        details.style.height = 'auto';
      } else {
        const summaryHeight = summary.offsetHeight;
        if (summaryHeight > 0) { // Only set if measurable
          details.style.height = summaryHeight + 'px';
        }
      }
    }
    
    // Initial setup
    setupAccordionStyles();
    
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      
      // Check if parent container is visible
      const container = details.closest('.measurement--collapsible');
      if (container && container.style.display === 'none') {
        return; // Don't animate if hidden
      }
      
      const isOpen = details.hasAttribute('open');
      const summaryHeight = summary.offsetHeight;
      
      if (summaryHeight === 0) {
        // If we can't measure, fall back to default behavior
        if (isOpen) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      
      if (isOpen) {
        // Closing animation
        const currentHeight = details.scrollHeight;
        details.style.height = currentHeight + 'px';
        
        // Force reflow
        details.offsetHeight;
        
        details.style.height = summaryHeight + 'px';
        
        setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 300);
        
      } else {
        // Opening animation
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        
        const fullHeight = details.scrollHeight;
        details.style.height = summaryHeight + 'px';
        
        // Force reflow
        details.offsetHeight;
        
        details.style.height = fullHeight + 'px';
        
        setTimeout(() => {
          details.style.height = 'auto';
        }, 300);
      }
    });
    
    // Handle window resize to recalculate heights
    function handleResize() {
      const container = details.closest('.measurement--collapsible');
      if (container && container.style.display === 'none') {
        return; // Skip if hidden
      }
      
      if (details.hasAttribute('open')) {
        details.style.height = 'auto';
      } else {
        const summaryHeight = summary.offsetHeight;
        if (summaryHeight > 0) {
          details.style.height = summaryHeight + 'px';
        }
      }
    }
    
    window.addEventListener('resize', handleResize);
    
    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
}

// Initialize accordions on page load
document.addEventListener('DOMContentLoaded', initializeAccordions);

// Re-initialize when sections are updated by variant script
window.addEventListener('sectionsUpdated', (event) => {
  // Small delay to allow DOM to update
  setTimeout(() => {
    initializeAccordions();
    
    // Reset accordion styles for newly visible elements
    document.querySelectorAll('.measurement--active [id^="Details-"]').forEach(details => {
      const summary = details.querySelector('summary');
      if (summary && summary.hasAttribute('data-accordion-initialized')) {
        details.style.transition = 'height 0.3s ease-out';
        details.style.overflow = 'hidden';
        
        if (details.hasAttribute('open')) {
          details.style.height = 'auto';
        } else {
          const summaryHeight = summary.offsetHeight;
          if (summaryHeight > 0) {
            details.style.height = summaryHeight + 'px';
          }
        }
      }
    });
  }, 50);
});


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );

    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__search-reset)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details:not(.mobile-facets__details)').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.sliderPagination = this.querySelector('.slider__pagination .dots');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // Mobile navigation with event delegation - handles re-rendering automatically
    this.initMobileNavigation();

    // Listen for variant changes to refresh mobile button states
    this.setupVariantChangeListener();
  }

  initMobileNavigation() {
    const mediaGallery = this.closest('media-gallery');
    if (!mediaGallery) return;

    // Use event delegation - listen on parent, handle mobile buttons anywhere
    mediaGallery.addEventListener('click', (e) => {
      if (e.target.matches('button[is="carousel-prev-button"]') || e.target.closest('button[is="carousel-prev-button"]')) {
        e.preventDefault();
        this.navigateMobile('prev');
      } else if (e.target.matches('button[is="carousel-next-button"]') || e.target.closest('button[is="carousel-next-button"]')) {
        e.preventDefault();
        this.navigateMobile('next');
      }
    });
  }

  setupVariantChangeListener() {
    // Listen for input changes (variant changes)
    document.addEventListener('change', (e) => {
      // Only run on mobile devices
      if (window.matchMedia('(max-width: 768px)').matches && 
          (e.target.matches('product-info input[name="id"]') || e.target.matches('product-info select[name="id"]'))) {
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          this.refreshMobileButtons();
        }, 150);
      }
    });

    // Also listen for form submissions
    document.addEventListener('submit', (e) => {
      // Only run on mobile devices
      if (window.matchMedia('(max-width: 768px)').matches && 
          e.target.closest('product-info product-form')) {
        setTimeout(() => {
          this.refreshMobileButtons();
        }, 150);
      }
    });
  }

  // refreshMobileButtons() {
  //   // Refresh slider items and offsets
  //   this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
  //   this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    
  //   if (this.sliderItemsToShow.length >= 2) {
  //     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
  //   }
    
  //   // Update mobile button states
  //   this.updateMobileButtons();
  // }

  refreshMobileButtons() {
    // Refresh slider items first
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    
    // Call initPages to properly recalculate everything including dots
    this.initPages();
  }

  navigateMobile(direction) {
    if (!this.slider || !this.sliderItemOffset) return;
    
    const step = 1;
    const newPosition = direction === 'next' 
      ? this.slider.scrollLeft + (step * this.sliderItemOffset)
      : this.slider.scrollLeft - (step * this.sliderItemOffset);
    
    this.setSlidePosition(newPosition);
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.createDots();
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  createDots() {
    if(this.sliderPagination) {
      this.sliderPagination.innerHTML = '';
      
      for(let i = 0; i < this.totalPages; i++) {
        let dot = document.createElement('div');
        dot.classList.add('dot');
        dot.setAttribute('data-index', i);
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToSlide(i);
        });
        
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('role', 'button');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        
        dot.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.goToSlide(i);
          }
        });
        
        this.sliderPagination.appendChild(dot);
      }
    }
  }

  goToSlide(slideIndex) {
    const targetPosition = slideIndex * this.sliderItemOffset;
    this.setSlidePosition(targetPosition);
  }

  updateDot() {
    if(this.sliderPagination) {
      this.sliderPagination?.querySelectorAll('.dot').forEach(x => x.classList.contains('active') ? x.classList.remove('active') : "");
      const activeDot = this.sliderPagination?.querySelectorAll('.dot')[this.currentPage - 1];
      if (activeDot) {
        activeDot.classList.add('active');
      }
    }
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    this.updateDot();

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    // Update regular buttons
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Update mobile buttons
    this.updateMobileButtons();
  }

  // Force update method for external calls (like variant changes)
  forceUpdate() {
    // Refresh slider items in case DOM changed
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    
    if (this.sliderItemsToShow.length >= 2) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    
    // Force update
    this.update();
  }

  updateMobileButtons() {
    const mediaGallery = this.closest('media-gallery');
    if (!mediaGallery) return;

    const mobileNext = mediaGallery.querySelector('button[is="carousel-next-button"]');
    const mobilePrev = mediaGallery.querySelector('button[is="carousel-prev-button"]');

    if (mobilePrev) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        mobilePrev.setAttribute('disabled', 'disabled');
        mobilePrev.style.opacity = '0.5';
      } else {
        mobilePrev.removeAttribute('disabled');
        mobilePrev.style.opacity = '1';
      }
    }

    if (mobileNext) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        mobileNext.setAttribute('disabled', 'disabled');
        mobileNext.style.opacity = '0.5';
      } else {
        mobileNext.removeAttribute('disabled');
        mobileNext.style.opacity = '1';
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

document.querySelector('.header__search')?.addEventListener('click', function() {
  if (isIOS()) {
    document.body.classList.add('ios-fix');
    document.body.classList.add('overflow-hidden');
  }
});

document.querySelector('.predictive-search-close')?.addEventListener('click', function() {
  document.body.classList.remove('overflow-hidden', 'ios-fix');
});

document.querySelector('.search-modal__close-button')?.addEventListener('click', function() {
  if (isIOS()) {
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden', 'ios-fix');
    }, 500); // Delay of 100ms, you can increase if needed
  }
});

// cross button on cookie
document.addEventListener("DOMContentLoaded", function () {
    const observeBanner = new MutationObserver(function (mutations, observer) {
        const banner = document.getElementById("shopify-pc__banner");
        if (banner) {
            // Stop observing once the banner is found
            observer.disconnect();

            // Select the body where the title is located
            const bannerBody = banner.querySelector(".shopify-pc__banner__body");
            const titleElement = bannerBody?.querySelector("#shopify-pc__banner__body-title");

            if (bannerBody && titleElement) {
                // Create a wrapper div
                const wrapperDiv = document.createElement("div");
                wrapperDiv.className = "cookie-banner-wrapper"; // Add a class for styling if needed
                wrapperDiv.style.display = "flex"; // Optional: for inline arrangement
                wrapperDiv.style.alignItems = "baseline"; // Optional: align items vertically
                wrapperDiv.style.justifyContent = "space-between"; // Optional: for spacing

                // Create the close icon
                const closeIcon = document.createElement("span");
                closeIcon.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path fill="#000" d="M7.41401 6.00012L11.707 1.70721C12.098 1.31622 12.098 0.684236 11.707 0.293244C11.316 -0.097748 10.684 -0.097748 10.293 0.293244L6.00001 4.58615L1.70701 0.293244C1.31601 -0.097748 0.684006 -0.097748 0.293006 0.293244C-0.0979941 0.684236 -0.0979941 1.31622 0.293006 1.70721L4.58601 6.00012L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.4141L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00012Z"></path></svg>`; // The x character
                closeIcon.style.cursor = "pointer";
                closeIcon.style.color = "#000"; // Optional: Change color if needed
                closeIcon.title = "Close";

                // Add a class for the close icon
                closeIcon.classList.add("cookie-banner-close", "shopify-pc__banner__btn-accept");
                closeIcon.id = "cookie-banner-close-icon";
                closeIcon.addEventListener("click", function () {
                    banner.style.display = "none";
                    localStorage.setItem("cookiesAccepted", "true");
                    const allCookies = document.cookie
                        .split("; ")
                        .map(cookie => decodeURIComponent(cookie))
                        .join("\n");
                    console.log("Cookies stored in the browser:\n" + allCookies);
                });

                // Wrap the title element and close icon
                titleElement.parentNode.insertBefore(wrapperDiv, titleElement); // Insert wrapper before the title
                wrapperDiv.appendChild(titleElement); // Move title into wrapper
                wrapperDiv.appendChild(closeIcon); // Add close icon to wrapper
            }
        }
    });

    // Start observing the DOM for changes
    observeBanner.observe(document.body, { childList: true, subtree: true });
});


// Nobl Air Price Toggle
document.addEventListener('DOMContentLoaded', () => {
  const PRODUCT_INFO_ID = 'MainProduct-template--26246258458924__main';
  const PRODUCT_ID = '10230577889580';

  const productInfo = document.querySelector(
    `product-info#${CSS.escape(PRODUCT_INFO_ID)}[data-product-id="${PRODUCT_ID}"]`
  );

  if (!productInfo) return;

  const clean = (text = '') => text.trim().replace(/\.00/g, '');

  const getText = (el) =>
    clean(el?.childNodes?.[0]?.textContent || el?.textContent || '');

  const setText = (el, text) => {
    if (el) el.textContent = text;
  };

  const ensureSaleHtml = () => {
    const priceContainer = productInfo.querySelector('.price__container');
    if (!priceContainer) return {};

    let regularPriceEl = productInfo.querySelector('.price__regular .price-item--regular');
    let saleWrapper = productInfo.querySelector('.price__sale');

    if (!saleWrapper) {
      saleWrapper = document.createElement('div');
      saleWrapper.className = 'price__sale';
      saleWrapper.innerHTML = `
        <span class="visually-hidden visually-hidden--inline">Sale price</span>
        <span class="price-item price-item--sale price-item--last"></span>
        <span class="compare-at__price">
          <s class="price-item price-item--regular"></s>
        </span>
      `;
      priceContainer.insertBefore(saleWrapper, priceContainer.firstChild);
    }

    return {
      regularPriceEl,
      salePriceEl: saleWrapper.querySelector('.price-item--sale'),
      comparePriceEl: saleWrapper.querySelector('.compare-at__price .price-item--regular'),
      saleWrapper,
      compareWrapper: saleWrapper.querySelector('.compare-at__price')
    };
  };

  const updatePrice = () => {
    const bundle = document.querySelector(`kaching-bundle[product-id="${PRODUCT_ID}"]`);
    if (!bundle) return;

    const bar =
      bundle.querySelector('.kaching-bundles__bar--selected') ||
      bundle.querySelector('.kaching-bundles__bar');

    if (!bar) return;

    const price = getText(bar.querySelector('[data-a11y-label="system.price"]'));
    const compare = getText(bar.querySelector('[data-a11y-label="system.original_price"]'));

    const priceBox = productInfo.querySelector('.price');
    const {
      regularPriceEl,
      salePriceEl,
      comparePriceEl,
      saleWrapper,
      compareWrapper
    } = ensureSaleHtml();

    if (price) {
      setText(regularPriceEl, price);
      setText(salePriceEl, price);
    }

    if (compare) {
      priceBox?.classList.add('price--on-sale');
      saleWrapper?.classList.remove('hidden');
      saleWrapper?.removeAttribute('hidden');
      compareWrapper?.classList.remove('hidden');
      compareWrapper?.removeAttribute('hidden');
      if (compareWrapper) compareWrapper.style.display = '';
      setText(comparePriceEl, compare);
    } else {
      priceBox?.classList.remove('price--on-sale');
      compareWrapper?.classList.add('hidden');
      compareWrapper?.setAttribute('hidden', '');
      if (compareWrapper) compareWrapper.style.display = 'none';
    }
  };

  const wait = setInterval(() => {
    const root = document
      .querySelector(`kaching-bundle[product-id="${PRODUCT_ID}"]`)
      ?.querySelector('.kaching-bundles');

    if (!root) return;

    clearInterval(wait);
    updatePrice();

    new MutationObserver(updatePrice).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }, 300);
});

/* Okendo Star Rating */
function formatReviewSummary() {
  document.querySelectorAll('.oke-sr-count-number').forEach((count) => {
    const reviewContainer = count.closest('.oke-sr');
    const ratingText = reviewContainer?.querySelector('.oke-a11yText');

    if (!ratingText || count.dataset.formatted === 'true') return;

    const ratingMatch = ratingText.textContent.match(
      /Rated ([\d.]+) out of 5 stars/
    );

    if (!ratingMatch) return;
    const rating = ratingMatch[1];
    //const rating = parseFloat(ratingMatch[1]).toString();

    const wrapper = document.createElement('span');
    wrapper.className = 'custom-review-summary';
    wrapper.textContent = `${rating}/5 - ${count.textContent.trim()}`;

    count.replaceWith(wrapper);
  });
}

const reviewObserver = new MutationObserver(() => {
  formatReviewSummary();
});

reviewObserver.observe(document.body, {
  childList: true,
  subtree: true
});

setTimeout(formatReviewSummary, 1000);


// custom block js for okendo

function injectReviewText() {
  var emptyBlock = document.querySelector('.oke-w-header-content-block--half.oke-w-header-content-block--center');
  if (emptyBlock && !emptyBlock.querySelector('.top-reviews-section')) {
    emptyBlock.innerHTML = `
      <div class="top-reviews-section">
        <div class="top-reviews-content">
        <div class="reviews-text cst-reviews-text">
            <p>CUSTOMER REVIEWS</p>
          </div>
          <h2 class="reviews-title">1 Million + Travelers Put it to the Test</h2>
          <div class="reviews-text">
            <p>Real journeys. Real packing. Reviews from travelers who chose NOBL.</p>
          </div>
        </div>
      </div>
    `;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  injectReviewText();
  // Keep watching in case Okendo re-renders and clears it
  var observer = new MutationObserver(injectReviewText);
  observer.observe(document.body, { childList: true, subtree: true });
});




//end of custom block js for okendo